<script>
import PopinTraiteurDeFetes from "@/components/organisms/popin-traiteur-de-fetes";
export default {
  components: { PopinTraiteurDeFetes },
  emits: ["closed"],
  computed: {
    traiteurDeFetesCategorySlug() {
      return useRuntimeConfig().public.TRAITEUR_DE_FETES_CATEGORY_SLUG;
    }
  },
  props: {
    showPlanningClickCollectTraiteur: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<template>
  <PopinTraiteurDeFetes
    :traiteur-de-fetes-category-slug="traiteurDeFetesCategorySlug"
    :show-planning-click-collect-traiteur="showPlanningClickCollectTraiteur"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    @closed="$emit('closed')"
  >
  </PopinTraiteurDeFetes>
</template>
